fragment ProductSliderFragment on productSlider_Entry {
  typeHandle
  layout
  heading
  backgroundColorGray
  image {
    url
    title
  }
  alt
  featureStyle
  featureText
  collectionOrProducts {
    typeHandle
    ... on products_Entry {
      shopifyHandle
    }
    ... on collections_Entry {
      collectionHandle
    }
  }
}
